const statusOf = (error: unknown): number | undefined => {
  if (typeof error !== "object" || error === null || !("status" in error)) {
    return undefined
  }

  if (
    error.status === "PARSING_ERROR" &&
    "originalStatus" in error &&
    typeof error.originalStatus === "number"
  ) {
    return error.originalStatus
  }

  return typeof error.status === "number" ? error.status : undefined
}

/**
 * Whether a failed refresh means the stored token is dead, as opposed to the server not answering.
 * Only a rejection should end the session: a 5xx or a dropped connection says nothing about
 * the token.
 */
export const isRefreshTokenRejected = (error: unknown): boolean => {
  const status = statusOf(error)

  return status === 400 || status === 401
}
